import { forwardRef } from 'react';

const variants = {
  primary:
    'bg-gradient-to-tr from-sky-500 to-blue-600 text-white font-black shadow-sm transition-transform hover:-translate-y-[1px] active:translate-y-0 disabled:opacity-60 disabled:cursor-not-allowed disabled:hover:translate-y-0',
  nomination:
    'relative text-sky-700 font-black tracking-tight whitespace-nowrap transition-opacity hover:opacity-90',
};

const sizes = {
  md: 'px-4 py-2 text-base',
  lg: 'px-4 py-3 text-lg',
};

const Button = forwardRef(function Button(
  { children, variant = 'primary', size = 'md', className = '', underline = false, disabled = false, ...props },
  ref
) {
  return (
    <button
      ref={ref}
      type="button"
      disabled={disabled}
      className={`
        rounded-xl text-center
        focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sky-400/40
        ${variants[variant]}
        ${sizes[size]}
        ${className}
      `.trim()}
      {...props}
    >
      {children}
      {underline && (
        <div
          className="absolute -bottom-2 left-0 w-full h-[4px]"
          style={{ background: 'currentColor' }}
        />
      )}
    </button>
  );
});

export default Button;
